import { SVGProps } from 'react';

export const BadgeBriefcaseIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2.2'
		strokeLinecap='round'
		strokeLinejoin='round'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<rect x='3.5' y='7.5' width='17' height='12.5' rx='2' />
		<path d='M9 7.5V5.8A1.8 1.8 0 0 1 10.8 4h2.4A1.8 1.8 0 0 1 15 5.8v1.7M3.5 12.5h17' />
	</svg>
);
